import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9h.01","key":"svg-0"}],["path",{"d":"M11 12h1v4h1","key":"svg-1"}]]

const IconInfoSmall = createReactComponent('outline', 'info-small', 'InfoSmall', __iconNode);

export default IconInfoSmall;